import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TopBar from './komponents/TopBar';
import SideBar from './komponents/SideBar';
import {Education} from './view/education';
import { Experience } from './view/experience';
import { Competencies } from './view/competencies';
import { Welcome } from './view/welcome';

function App() {
  return (
    <div className="App">
    <BrowserRouter>
      <TopBar />
      <div className="main-content">
        <SideBar />
        <div className="content">
          <Routes>
            <Route path="/education" element={<Education />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/competencies" element={<Competencies />} />
            <Route path="/" element={<Welcome />} />
            {/* Andra routes här om nödvändigt */}
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  </div>
);
}

export default App;
